cv.PublicTeamsRowEmptyView = Marionette.LayoutView.extend({
  className: 'team-empty',
  template: cv.Templates['public/teams/teams_row_empty'],

  events : {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    console.log('PublicTeamsRowEmptyView initialized');
  },

  onShow: function(){
  }
});
